export default (baseUrl) => ({
  getFullUrl(path) {
      let url = new URL(path, baseUrl);
      const queryParams = new URLSearchParams(window.location.search);
      url.search = queryParams.toString();
      return url.toString();
  },

  logout() {
    // Voláme logout z Alpine store, který odstraní cookie a přesměruje uživatele
    Alpine.store('auth').logout();
  }
});
